import { Tooltip } from 'antd';
import type { FC } from 'react';

import type { GeoChartMeta } from '../../types';
import type { TestingWithLevel } from './GeoChartBodyPicture';
import { PERFORATION_WIDTH } from '../../base';

const MIN_TESTING_HEIGHT = 63;

const getIndent = (roof: number, bottom: number) => {
    const heigh = bottom - roof;
    const baseIndent = 16;
    if (heigh > MIN_TESTING_HEIGHT) {
        return baseIndent;
    } else {
        return (heigh - MIN_TESTING_HEIGHT) / 2 + baseIndent;
    }
};

export const TestingComponent: FC<TestingWithLevel & { x: number; meta: GeoChartMeta }> = ({
    absBottom,
    absRoof,
    roof,
    bottom,
    x,
    level,
    meta,
    params,
}) => {
    const { depthToPixelsY } = meta.depths;
    const NEEDED_PARAMS = [
        'Дебит нефти',
        'Динамический уровень',
        'Газовый фактор',
        'Температура пласта',
        'Примечание',
        'Время притока',
        'Объем флюида',
        'Тип полученного флюида',
    ];
    const filteredParams = params.filter(({ title }) => NEEDED_PARAMS.includes(title));

    const indent = getIndent(depthToPixelsY(roof), depthToPixelsY(bottom));
    const xWithLevel = x + level * PERFORATION_WIDTH;

    return (
        <>
            <path
                d={`
                M ${xWithLevel + 1} ${depthToPixelsY(-absRoof)}
                L ${xWithLevel + 25} ${depthToPixelsY(-absRoof)}
                L ${xWithLevel + 13} ${depthToPixelsY(-absBottom)}
                Z
            `}
                fill="transparent"
                stroke="#F00"
            />
            <Tooltip
                title={filteredParams.map(({ title, value, units }) => (
                    <>
                        <span className="text-xxs">{`${title}: ${value}${units ?? ''}`}</span>
                        <br />
                    </>
                ))}
            >
                <text
                    x={x + 37}
                    y={depthToPixelsY(-(absRoof + absBottom) / 2)}
                    fill={'currentColor'}
                    fontSize={10}
                    textAnchor="middle"
                    className="cursor-pointer"
                    transform={`rotate(-90, ${xWithLevel + 37}, ${depthToPixelsY(-(absRoof + absBottom) / 2)})`}
                >
                    {filteredParams.map(({ title, value, units }, index) => {
                        return (
                            <tspan key={`${value}${index}`} x={xWithLevel + 37} dy={`${index === 0 ? 0 : 1.2}em`}>
                                {`${title}: ${value}${units ?? ''}`}
                            </tspan>
                        );
                    })}
                </text>
            </Tooltip>
            <Tooltip title={<span className="text-xxs">{`${roof} (${absRoof})`}</span>}>
                <text
                    x={x}
                    y={depthToPixelsY(-absRoof) + indent}
                    fill={'currentColor'}
                    fontSize={10}
                    textAnchor="end"
                    className="cursor-pointer"
                >
                    <tspan x={x - 4} dy={0}>
                        {roof}
                    </tspan>
                    <tspan x={x - 4} dy="1.2em">
                        ({absRoof})
                    </tspan>
                </text>
            </Tooltip>
            <Tooltip title={<span className="text-xxs">{`${bottom} (${absBottom})`}</span>}>
                <text
                    x={x}
                    y={depthToPixelsY(-absBottom) - indent}
                    fill={'currentColor'}
                    fontSize={10}
                    textAnchor="end"
                    className="cursor-pointer"
                >
                    <tspan x={x - 4} dy={0}>
                        {bottom}
                    </tspan>
                    <tspan x={x - 4} dy="1.2em">
                        ({absBottom})
                    </tspan>
                </text>
            </Tooltip>
        </>
    );
};
